import styled from 'styled-components';
import {
  space,
  SpaceProps,
  ColorProps,
  color,
  TypographyProps,
  typography
} from 'styled-system';

export const StyledTitle = styled.div<
  SpaceProps & ColorProps & TypographyProps
>`
  width: 100%;
  background-color: transparent;
  color: ${({ theme }): string => theme.colors.normalText};
  font-size: ${({ theme }): string => theme.fontSizes[4]};
  font-weight: 500;
  display: flex;
  justify-content: center;
  align-items: center;
  ${color}
  ${space}
  ${typography}
`;

export const StyledTitleBorder = styled.div`
  height: 1px;
  flex: 1;
  background-color: ${({ theme }): string => theme.colors.border};
`;
